export default __webpack_public_path__ + "72feefa1587903f989e72e548f49cdf6.svg";